import { useState } from 'react';

import useGetAllActiveShifts from '../jobs/useGetAllActiveShifts';
import useGetCreatedJobPosts from '../jobs/useGetCreatedJobPosts';
import useGetJobApplicationStats from '../jobs/useGetJobApplicationStats';
import useGetTotalApplicationsCount from '../jobs/useGetTotalApplicationsCount';
import useGetActiveJobApplications from '../jobs/useGetActiveJobApplications';
import useGetPendingApplications from '../jobs/useGetPendingJobApplications';
import useGetBookmarkedLocumJobs from '../jobs/useGetBookmarkedLocumJobs';
import useGetBannerNotifications from '../../../hooks/dashboard/notifications/bannerNotifications/useGetBannerNotifications';
import useGetAvailabilityCount from '../settings/profilesetting/useGetAvailabilityCount';

const useDashboardLoading = () => {
  const [loading, setLoading] = useState(false);
  const { getJobApplicationStats } = useGetJobApplicationStats();
  const { getCreatedJobPosts } = useGetCreatedJobPosts();
  const { getAllActiveShifts } = useGetAllActiveShifts();
  const { getTotalApplicationsCount } = useGetTotalApplicationsCount();
  const { getActiveJobApplications } = useGetActiveJobApplications();
  const { getPendingApplications } = useGetPendingApplications();
  const { getBookmarkedLocumJobs } = useGetBookmarkedLocumJobs();
  const { getBannerNotifications } = useGetBannerNotifications();
  const { getAvailabilityCount } = useGetAvailabilityCount();

  const getDashboardLoadingData = (userId: string) => {
    if (!userId) return Promise.resolve();

    setLoading(true);
    return Promise.all([
      getJobApplicationStats(),
      getCreatedJobPosts({ page: '1' }, userId),
      getAllActiveShifts(),
      getTotalApplicationsCount(),
      getActiveJobApplications(),
      getPendingApplications(),
      getBookmarkedLocumJobs(),
      getBannerNotifications(),
      getAvailabilityCount(),
    ]).finally(() => setLoading(false));
  };

  return { getDashboardLoadingData, loading };
};

export default useDashboardLoading;
